import { collectNumbers, keltnerSeries, numericExtent } from "../utils";
const KELTNER = {
    name: "Keltner",
    compute: (bars, period = 20, atrPeriod = 10, multiplier = 2) => {
        return keltnerSeries(bars, period, atrPeriod, multiplier);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default KELTNER;
